import React, { useEffect } from 'react';
import { Button, ButtonToolbar, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import validate from './Validate';
import renderField from '../../../shared/components/form/RenderField';

const AnalysisItemForm = (props) => {
  const { t, initialize, handleSubmit, backHandler, dto } = props;

  useEffect(() => {
    initialize(dto);
  }, []);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.name')}</span>
        <div className="form__form-group-field">
          <Field
            name="name"
            type="text"
            component={renderField}
            maxLength="200"
            placeholder={t('placeholder.analysis-item.name')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.order')}</span>
        <div className="form__form-group-field">
          <Field
            name="order"
            type="number"
            component={renderField}
            maxLength="3"
            placeholder={t('placeholder.analysis-item.order')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.description')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="description"
            type="text"
            component="textarea"
            maxLength="250"
            placeholder={t('placeholder.analysis-item.description')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <div className="form__form-group-field">
          <Label className="generic__label">{t('general.active')}</Label>
          <Field
            name="active"
            component={renderCheckBoxField}
            className="colored-click"
          />
        </div>
      </div>
      <ButtonToolbar className="form__button-toolbar">
        <Button color="primary" onClick={backHandler}>
          {t('general.back')}
        </Button>
        <Button color="success" type="submit">
          {t('general.save')}
        </Button>
      </ButtonToolbar>
    </form>
  );
};

AnalysisItemForm.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  dto: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    active: PropTypes.bool,
  }),
};

AnalysisItemForm.defaultProps = {
  dto: null,
};

export default reduxForm({
  form: 'AnalysisItemForm',
  validate,
})(withTranslation('common')(AnalysisItemForm));
